<template>
    <b-container class="container-panel">
        <AmbitLogo></AmbitLogo>
        <b-card no-body>
            <b-card-header><h4>Manage Payment Methods</h4></b-card-header>
            <b-card-body>
                <b-form @submit.stop.prevent>
                    <label for="aNumber">ANumber</label>
                    <b-input v-model="aNumber" id="account-number"></b-input>
                    <label for="accountType">Key Type</label>
                    <b-input v-model="accountType" id="account-type"></b-input>
                    <label for="campaign">Campaign</label>
                    <b-input v-model="campaign" id="campaign"></b-input>
                    <label for="callBack">Callback URL</label>
                    <b-input v-model="callBack" id="callBack"></b-input>
                    <label for="agent">Agent Id</label>
                    <b-input v-model="agent" id="agent"></b-input>
                    <b-button @click="submit" class="mt-3">Submit</b-button>
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>

</template>

<script>
import AmbitLogo from '../components/AmbitLogo.vue';
    export default {
  name: "EditPaymentMethods",
  components: {AmbitLogo},
  data: () => ({
      accountType: "CUSTOMER",
    aNumber: "A3307215",
      campaign: "BLUENET",
      countryCode: "US",
    agent: "bluenet/test",
    callBack: "https://www.ambitenergy.com"
        }),
    mounted(){
        if (window.location.href.includes("localhost") || window.location.href.includes("int")) {
            //
        } else {
            this.$router.push('/');
        }
    },
  methods: {
      submit: async function () {
          var additionalParameters = Object.assign(
          {},
          {
            CreditCardProcessingFee: this.creditCardFee,
            AgentProcessingFee: this.agentFee,
            Agent: this.agent
          }
        );
        var body = Object.assign(
          {},
          {
            ExternalKeyValue: this.aNumber,
            ExternalKeyType: this.accountType,
            PaymentCampaignCode: this.campaign,
            CallBackUrl: this.callBack,
            CountryCode: this.countryCode,
            DisplayLanguageOptions: ["en", "sp"],
            AdditionalParameters: additionalParameters
          }
          );
        this.$store.dispatch("lobby/getPaymentMethodToken", body);
    }
  }
};
</script>
